import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  checked?: boolean;
}

export const Root = styled.div`
  margin: 45px 60px 0px 60px;
`

export const Title = styled.span`
  display: block;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`
export const Col = styled.div`
  width: auto;
  display: inline-block;
`;

export const Folders = styled.div`
  margin-top: 41px;
`
export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`
export const Icon = styled.svg`
  fill: none;
  stroke: #204078;
  stroke-width: 2px;
`
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  width: 23px;
  height: 21px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  opacity:-1;
`

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 23px;
  height: 21px;
  border-radius: 2px;
  border: solid 1px rgba(18, 36, 66, 0.2);
  background: ${(props: IRootProps) => props.checked ? '#ffffff' : '#fffffff'};
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    border-radius: 2px;
    border: solid 1px #122442;
  }
  ${Icon} {
    visibility: ${(props: IRootProps) => props.checked ? 'visible' : 'hidden'};
  }
`
export const Label = styled.label`
  margin-left: 15px; 
  font-size: 18px;
  font-weight: normal;
  color: ${C.DARK_BLUE};
`